import Vue from "vue";
import Router from "vue-router";
import store from "@/store/";
import Home from "./views/Home.vue";
import SMS from "./views/SMS.vue";
import Login from "./views/Login.vue";
import Dashboard from "./views/Dashboard.vue";
import LoginApi from "@/services/login";
import Enviados from "./views/Enviados.vue";
import Noenviados from "./views/Errores.vue";
// import Permisos from "./views/Permisos.vue";
// import SinPermiso from "./views/SinPermiso.vue";
// import { Loading } from "element-ui";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/",
      name: "login",
      component: Login,
      meta: {
        isPublic: true,
        isLog: true
      }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/sms",
      name: "SMS",
      component: SMS,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/enviados",
      name: "Enviados",
      component: Enviados,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/noenviados",
      name: "Noenviados",
      component: Noenviados,
      meta: {
        isPublic: false
      }
    }
    // {
    //   path: "/sinpermiso",
    //   name: "sinpermiso",
    //   component: SinPermiso,
    //   meta: {
    //     isPublic: false
    //   }
    // },
    // {
    //   path: "/permisos",
    //   name: "permisos",
    //   component: Permisos,
    //   meta: {
    //     isPublic: false
    //   }
    // },
  ]
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.isPublic);
  if (requiresAuth === false) {
    LoginApi.refreshtoken()
      .then(res => {
        store.dispatch("setuser", res.data.usuario);
        next();
      })
      .catch(error => {
        console.log(error);
        next("/");
      });
  } else {
    if (to.path == "/") {
      LoginApi.refreshtoken()
        .then(res => {
          store.dispatch("setuser", res.data.usuario);
          next("/home");
        })
        .catch(error => {
          // next("/login");
        });
    }
    next();
  }
});

export default router;
